// All mock data for the Farmway frontend. Later replaced by real backend where needed.

export const IMAGES = {
  // Hero / backgrounds
  heroAerial: 'https://images.unsplash.com/photo-1511802269876-bf873cc7b2c5',
  fieldsGold: 'https://images.unsplash.com/photo-1516822277566-bb38424a2b77',
  lushGreen: 'https://images.pexels.com/photos/32162204/pexels-photo-32162204.jpeg',
  goldenSunset: 'https://images.unsplash.com/photo-1495107334309-fcf20504a5ab',
  countryside: 'https://images.pexels.com/photos/24363079/pexels-photo-24363079.jpeg',
  appleOrchard: 'https://images.unsplash.com/photo-1727120279660-5c28b8461609',
  // People / story
  farmerPortrait: 'https://images.unsplash.com/photo-1670927519969-dc5065aa5641',
  fishFarm1: 'https://images.pexels.com/photos/18640095/pexels-photo-18640095.jpeg',
  fishFarm2: 'https://images.pexels.com/photos/19780693/pexels-photo-19780693.jpeg',
  foodProcessing: 'https://images.unsplash.com/photo-1651525669944-00de65d3b8a5',
  // Crops
  almondAerial: 'https://images.unsplash.com/photo-1637048716718-1229686e88fd',
  almondBlossom: 'https://images.unsplash.com/photo-1596812178489-6e902597bacc',
  blueberry: 'https://images.pexels.com/photos/8754397/pexels-photo-8754397.jpeg',
  blueberry2: 'https://images.pexels.com/photos/8754403/pexels-photo-8754403.jpeg',
  saffronField: 'https://images.unsplash.com/photo-1760982685687-fed74d29d73b',
  saffronClose: 'https://images.pexels.com/photos/34060195/pexels-photo-34060195.jpeg',
  oliveGrove: 'https://images.unsplash.com/photo-1544475925-9199e8ed85ab',
  pistachio: 'https://images.unsplash.com/photo-1676882339777-94e90110dfc6',
  cinnamon: 'https://images.unsplash.com/photo-1622798337764-259682f03741',
  rollingHills: 'https://images.unsplash.com/photo-1553307236-8783cc0a3b9e',
  grassland: 'https://images.unsplash.com/uploads/1412026095116d2b0c90e/3bf33993',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'What We Offer', path: '/what-we-offer' },
  { label: 'Investment Opportunities', path: '/investment-opportunities' },
  { label: 'Our Growth', path: '/our-growth' },
];

// Home hero highlight pillars
export const PILLARS = [
  {
    icon: 'ShieldCheck',
    title: 'Inflation Proof',
    text: 'Real, productive farmland assets that hold value and grow through market cycles.',
  },
  {
    icon: 'FileSignature',
    title: 'Direct Ownership',
    text: 'Fractional, transparent ownership of curated agricultural projects worldwide.',
  },
  {
    icon: 'Sprout',
    title: 'Sustainable Food Security',
    text: 'Capital that regenerates land while nourishing a growing world.',
  },
];

export const OFFER_STATS = [
  { icon: 'Coins', value: '$500', label: 'To start investment' },
  { icon: 'Globe', value: 'Worldwide', label: 'Investment options' },
  { icon: 'Wallet', value: 'Fiat & Crypto', label: 'Payment modes' },
];

export const IMPACT_STATS = [
  { value: '$100M+', label: 'Targeted asset base by 2024' },
  { value: '9 / 17', label: 'UN Sustainable Development Goals' },
  { value: '6', label: 'Countries with active projects' },
  { value: '2yrs', label: 'From genesis to $30M base' },
];

export const COUNTRIES = ['All', 'Georgia', 'India', 'Sri Lanka', 'UAE'];
export const STATUS_FILTERS = ['All', 'Open', 'Upcoming'];

export const PROJECTS = [
  {
    id: 'geo-almond-1',
    name: 'Georgia Almond I',
    location: 'Kakheti',
    country: 'Georgia',
    crop: 'Almonds & Olive',
    size: '62.5 Ha',
    projectSize: 'USD 1,750,000',
    status: 'Open',
    image: IMAGES.almondAerial,
    metrics: { irr: '16.2%', multiple: '3.5x', yield: '13.50%', hold: '10 yrs' },
    summary:
      'A flagship almond and olive orchard in the fertile Kakheti valley, structured for long-term regenerative yield.',
  },
  {
    id: 'geo-almond-2',
    name: 'Georgia Almond II',
    location: 'Kakheti',
    country: 'Georgia',
    crop: 'Almonds & Olive',
    size: '62.5 Ha',
    projectSize: 'USD 1,750,000',
    status: 'Open',
    image: IMAGES.oliveGrove,
    metrics: { irr: '16.2%', multiple: '3.5x', yield: '13.50%', hold: '10 yrs' },
    summary:
      'Expanding our proven Kakheti almond model with intercropped olive for diversified, resilient returns.',
  },
  {
    id: 'ind-blueberry-1',
    name: 'India Blueberry I',
    location: 'Solan',
    country: 'India',
    crop: 'Blueberry',
    size: '6 Ha',
    projectSize: 'USD 4,000,000',
    status: 'Upcoming',
    image: IMAGES.blueberry,
    metrics: { irr: '21%', multiple: '5.5x', yield: '16.00%', hold: '4 yrs' },
    summary:
      'High-value protected blueberry cultivation targeting premium fresh markets across Asia and the Gulf.',
  },
  {
    id: 'ind-saffron-1',
    name: 'India Saffron I',
    location: 'Kashmir',
    country: 'India',
    crop: 'Saffron',
    size: '11 Ha',
    projectSize: 'USD 6,000,000',
    status: 'Upcoming',
    image: IMAGES.saffronField,
    metrics: null,
    summary:
      "Reviving Kashmir's storied saffron heritage with modern agronomy and full-traceability processing.",
  },
  {
    id: 'ind-ashwagandha-1',
    name: 'India Ashwagandha I',
    location: 'Uttarakhand',
    country: 'India',
    crop: 'Ashwagandha',
    size: '20 Ha',
    projectSize: 'USD 6,000,000',
    status: 'Open',
    image: IMAGES.rollingHills,
    metrics: null,
    summary:
      'Certified-organic medicinal herb cultivation feeding the booming global nutraceutical demand.',
  },
  {
    id: 'ind-lavender-1',
    name: 'India Lavender',
    location: 'Himachal Pradesh',
    country: 'India',
    crop: 'Lavender',
    size: '10 Ha',
    projectSize: 'USD 6,000,000',
    status: 'Open',
    image: IMAGES.saffronClose,
    metrics: null,
    summary:
      "Aromatic lavender estates in the Himalayan foothills, distilling premium essential oils.",
  },
  {
    id: 'lka-cinnamon-1',
    name: 'Sri Lanka Cinnamon I',
    location: 'Kandy',
    country: 'Sri Lanka',
    crop: 'Cinnamon & Mace',
    size: '80 Ha',
    projectSize: 'USD 1,000,000',
    status: 'Open',
    image: IMAGES.cinnamon,
    metrics: null,
    summary:
      "True Ceylon cinnamon spice gardens with world-renowned provenance and export demand.",
  },
  {
    id: 'geo-pistachio-1',
    name: 'Georgia Pistachio I',
    location: 'Kakheti',
    country: 'Georgia',
    crop: 'Pistachio',
    size: '60 Ha',
    projectSize: 'USD 2,250,000',
    status: 'Upcoming',
    image: IMAGES.pistachio,
    metrics: null,
    summary:
      'Drought-resilient pistachio plantations diversifying our Kakheti tree-nut portfolio.',
  },
  {
    id: 'geo-almond-5',
    name: 'Georgia Almond V',
    location: 'Kakheti',
    country: 'Georgia',
    crop: 'Almonds',
    size: '42 Ha',
    projectSize: 'USD 1,200,000',
    status: 'Upcoming',
    image: IMAGES.almondBlossom,
    metrics: null,
    summary:
      'Next-phase almond orchard scaling our most productive variety in prime Kakheti terroir.',
  },
  {
    id: 'uae-foodpro-1',
    name: 'UAE FoodPro I',
    location: 'Al Ain',
    country: 'UAE',
    crop: 'Processing · Oil & Extracts',
    size: '1 Ha',
    projectSize: 'USD 8,000,000',
    status: 'Upcoming',
    image: IMAGES.foodProcessing,
    metrics: null,
    summary:
      'A state-of-the-art food processing facility adding value across our tree-nut supply chain.',
  },
  {
    id: 'ind-foodpro-1',
    name: 'India FoodPro I',
    location: 'Delhi NCR',
    country: 'India',
    crop: 'Processing · Oil & Extracts',
    size: '3 Ha',
    projectSize: 'USD 12,000,000',
    status: 'Upcoming',
    image: IMAGES.appleOrchard,
    metrics: null,
    summary:
      'Large-scale processing under the Make in India scheme, unlocking export-grade extracts.',
  },
  {
    id: 'geo-almond-8',
    name: 'Georgia Almond VIII',
    location: 'Kakheti',
    country: 'Georgia',
    crop: 'Almonds',
    size: '80 Ha',
    projectSize: 'USD 2,250,000',
    status: 'Upcoming',
    image: IMAGES.lushGreen,
    metrics: null,
    summary:
      'Our largest single almond estate to date, engineered for regenerative, high-density yield.',
  },
];

export const TIMELINE = [
  {
    year: '2020',
    items: ['Genesis of Farmway as a disruptor in the Agri-Fin Tech space'],
  },
  {
    year: '2021',
    items: [
      'Land acquisitions in Kakheti, Georgia',
      'Land acquisitions in Kandy, Sri Lanka',
      'Land acquisitions in Uttarakhand, India',
      '1st almond orchard launched in Kakheti, Georgia',
    ],
  },
  {
    year: '2022',
    items: [
      '3 almond farms added in Kakheti, Georgia',
      'Ashwagandha farm added in India',
      'Receipt of USAID and EU grant approvals for 600 ha',
    ],
  },
  {
    year: '2023',
    items: [
      '6 almond orchards launched in Kakheti, Georgia',
      'Land acquisition in Dalat, Vietnam',
      'Trading company set up in Hong Kong',
      '1st Pistachio orchard launched in Kakheti, Georgia',
      'Saffron and Lavender testing commenced',
    ],
  },
  {
    year: '2024',
    items: [
      '1st Blueberry orchard launched in Solan, India',
      'Food processing launched under Make in India (UP & Gujarat)',
      'Industrial area acquisition in Al Ain, UAE',
      'Receipt of USAID green energy grant in India',
      'Commenced spice orchard preparation in Kandy, Sri Lanka',
    ],
  },
];

// Brand channels from the design system (The Theater / TV / Magazine / Boardroom)
export const CHANNELS = [
  { name: 'LinkedIn', role: 'The Theater', desc: 'Official communication & capital updates', icon: 'Linkedin' },
  { name: 'Instagram', role: 'The TV', desc: 'Visual brand world & storytelling', icon: 'Instagram' },
  { name: 'X', role: 'The Magazine', desc: 'Real-time macro & RWA thought leadership', icon: 'Twitter' },
  { name: 'Community', role: 'The Boardroom', desc: 'High-touch CRM & early access', icon: 'MessageCircle' },
];

// LocalStorage helper for the (frontend-only) connect form
export const saveInquiry = (data) => {
  try {
    const existing = JSON.parse(localStorage.getItem('fw_inquiries') || '[]');
    existing.push({ ...data, at: new Date().toISOString() });
    localStorage.setItem('fw_inquiries', JSON.stringify(existing));
  } catch (e) {
    // ignore
  }
};
